import { useMapEvents } from "react-leaflet";

//const NOMINATIM_API_URL = "https://nominatim.openstreetmap.org/reverse";
const SEARCH_NOMINATIM_API_URL = "https://nominatim.openstreetmap.org/search";

export function MapCityFinder({ setCityState, setStateCode }: any) {
    const map = useMapEvents({
        zoomend: () => {
            const center = map.getBounds();
            const southwest = center.getSouthWest();
            const northEast = center.getNorthEast();
            fetch(`${SEARCH_NOMINATIM_API_URL}?q=city&format=json&addressdetails=1&bounded=1&viewbox=${southwest.lng},${southwest.lat},${northEast.lng},${northEast.lat}&countrycodes=US&limit=50`)
                .then((res) => res.json())
                .then((data) => {
                    let responseDataStateCity: any[] = [];
                    let responseState: string[] = [];
                    if(data?.length > 0) {
                        data?.forEach((element: any) => {
                            if (element && element.address) {
                                const state = element.address.state;
                                const city = element.address.city || element.address.town || element.address.village;
                                responseDataStateCity.push(
                                    {
                                        state:state, 
                                        city: city?.toUpperCase()
                                    }
                                );
                                responseState.push(state)
                            }
                        })
                    }
                    setCityState(responseDataStateCity);
                    setStateCode(responseState);
                })
                .catch((err) => console.error('Error fetching city data:', err));
        },
    })
    return null;
}